import { memo } from 'react'

const UnmuteIcon: React.FC = memo(() => (
  <svg
    className="tc-mic-unmuted"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_655_3824)">
      <path
        d="M8.67241 11.8448C9.49524 11.844 10.2841 11.5167 10.8659 10.9349C11.4478 10.3531 11.775 9.5642 11.7759 8.74138V4.60345C11.7759 3.78036 11.4489 2.99099 10.8669 2.40898C10.2849 1.82697 9.4955 1.5 8.67241 1.5C7.84933 1.5 7.05995 1.82697 6.47794 2.40898C5.89594 2.99099 5.56897 3.78036 5.56897 4.60345V8.74138C5.56982 9.5642 5.89707 10.3531 6.47889 10.9349C7.06071 11.5167 7.84959 11.844 8.67241 11.8448ZM6.60345 4.60345C6.60345 4.05472 6.82143 3.52847 7.20943 3.14047C7.59744 2.75246 8.12369 2.53448 8.67241 2.53448C9.22114 2.53448 9.74739 2.75246 10.1354 3.14047C10.5234 3.52847 10.7414 4.05472 10.7414 4.60345V8.74138C10.7414 9.2901 10.5234 9.81635 10.1354 10.2044C9.74739 10.5924 9.22114 10.8103 8.67241 10.8103C8.12369 10.8103 7.59744 10.5924 7.20943 10.2044C6.82143 9.81635 6.60345 9.2901 6.60345 8.74138V4.60345ZM9.18965 13.8879V15.9828C9.18965 16.1199 9.13516 16.2515 9.03816 16.3485C8.94116 16.4455 8.80959 16.5 8.67241 16.5C8.53523 16.5 8.40367 16.4455 8.30667 16.3485C8.20967 16.2515 8.15517 16.1199 8.15517 15.9828V13.8879C6.87994 13.7582 5.69812 13.1601 4.83826 12.2095C3.9784 11.2589 3.50158 10.0232 3.5 8.74138C3.5 8.6042 3.5545 8.47264 3.6515 8.37563C3.7485 8.27863 3.88006 8.22414 4.01724 8.22414C4.15442 8.22414 4.28598 8.27863 4.38299 8.37563C4.47999 8.47264 4.53448 8.6042 4.53448 8.74138C4.53448 9.83883 4.97044 10.8913 5.74645 11.6673C6.52247 12.4434 7.57497 12.8793 8.67241 12.8793C9.76986 12.8793 10.8224 12.4434 11.5984 11.6673C12.3744 10.8913 12.8103 9.83883 12.8103 8.74138C12.8103 8.6042 12.8648 8.47264 12.9618 8.37563C13.0588 8.27863 13.1904 8.22414 13.3276 8.22414C13.4648 8.22414 13.5963 8.27863 13.6933 8.37563C13.7903 8.47264 13.8448 8.6042 13.8448 8.74138C13.8433 10.0232 13.3664 11.2589 12.5066 12.2095C11.6467 13.1601 10.4649 13.7582 9.18965 13.8879Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_655_3824">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
))

export { UnmuteIcon }
